import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const UpdateProfile = ({ setUser }) => {
  const [profileImg, setProfileImg] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [address, setAddress] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const currentUser =
      JSON.parse(localStorage.getItem('currentUser')) ||
      JSON.parse(localStorage.getItem('loggedInUser'));

    if (currentUser) {
      setName(currentUser.name || '');
      setEmail(currentUser.email || '');
      setPhone(currentUser.phone || '');
      setProfileImg(currentUser.profileImg || '');
      setGender(currentUser.gender || '');
      setDob(currentUser.dob || '');
      setAddress(currentUser.address || '');
    } else {
      navigate('/login');
    }
  }, [navigate]);

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setProfileImg(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveProfileImage = () => {
    setProfileImg('');
    toast.info('Profile image removed');
  };

  const handleUpdateProfile = (e) => {
    e.preventDefault();

    const updatedUser = {
      name,
      email,
      phone,
      gender,
      dob,
      address,
      profileImg,
      createdAt: new Date().toISOString(), // update createdAt if needed
    };

    localStorage.setItem('currentUser', JSON.stringify(updatedUser));
    localStorage.setItem('loggedInUser', JSON.stringify(updatedUser));
    setUser(updatedUser);

    toast.success('Profile updated successfully');
    navigate('/profile');
  };

  return (
    <div className="container py-5">
      <div className="text-center mb-4">
        <h2 className="fw-bold">Update Profile</h2>
        <p className="text-muted">Update your personal details</p>
      </div>

      <div className="card p-4 shadow mx-auto" style={{ maxWidth: '650px' }}>
        <form onSubmit={handleUpdateProfile}>
          <div className="mb-3 text-center">
            {profileImg ? (
              <img
                src={profileImg}
                alt="Profile Preview"
                width="100"
                height="100"
                style={{ borderRadius: '50%' }}
              />
            ) : (
              <div
                style={{
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  backgroundColor: '#ccc',
                  margin: '0 auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.5rem',
                  color: '#fff'
                }}
              >
                {name?.charAt(0).toUpperCase() || 'U'}
              </div>
            )}
            {profileImg && (
              <button
                type="button"
                className="btn btn-danger btn-sm mt-2"
                onClick={handleRemoveProfileImage}
              >
                Remove Image
              </button>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="profileImage" className="form-label">Profile Image</label>
            <input
              type="file"
              id="profileImage"
              className="form-control"
              accept="image/*"
              onChange={handleProfileImageChange}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Phone</label>
            <input
              type="tel"
              className="form-control"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Gender</label>
            <select
              className="form-select"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              required
            >
              <option value="">Select gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Date of Birth</label>
            <input
              type="date"
              className="form-control"
              value={dob}
              onChange={(e) => setDob(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Address</label>
            <textarea
              className="form-control"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              rows="2"
              required
            ></textarea>
          </div>

          <button type="submit" className="btn btn-primary w-100">Save Changes</button>
        </form>
      </div>
    </div>
  );
};

export default UpdateProfile;
